import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo, { breadcrumbLd, ogUrl } from "@/components/site/Seo";
import { IndustryCards } from "@/components/site/PublicPresentation";

export default function Categories() {
  return (
    <SiteLayout>
      <Seo
        title="Sourcing Categories — Fasteners, Textiles, Electronics & More | The Sourcing Atlas"
        description="Eight product categories, honestly tiered: what we source direct, what we buy every quarter, and what we source through vetted specialist partners across China, India, Vietnam and Thailand."
        path="/categories"
        ogImage={ogUrl("Eight Categories. Honestly Tiered.", "What We Source")}
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Categories", path: "/categories" }])]}
      />
      <div className="crumb"><Link to="/">Home</Link> › Categories</div>
      <div className="pband"><div className="pband-in"><span className="tierpill tn">OUR INDUSTRY EXPERTISE</span><h1 data-testid="categories-title">Sourcing knowledge.<br />Grounded in your industry.</h1><p className="lede">Deep expertise, regular buying experience and trusted specialist partners. Eight core categories, with a transparent view of where our strengths lie.</p></div></div>
      <section><div className="wrap"><IndustryCards full /></div></section>
    </SiteLayout>
  );
}
